import { render, staticRenderFns } from "./SaleTaxGroupUpdate.vue?vue&type=template&id=201a7a80&"
import script from "./SaleTaxGroupUpdate.vue?vue&type=script&lang=ts&"
export * from "./SaleTaxGroupUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports